// extracted by mini-css-extract-plugin
export default {"cards":"IconCardSlice_cards__8xRKZ","card":"IconCardSlice_card__Y4hDc","headline":"IconCardSlice_headline__af+tf","cardHeadline":"IconCardSlice_cardHeadline__ke9Kb"};